/* Start importing seperated js files */
import {
    primaryNavHandler,
    moreItemsToggleHandler,
    highlightSubNavHandler,
    getHeightSideNav,
    mobileMenuButtonHandler,
    thirdLevelMenuHandler,
    mobileMenuArrowHAndler,
    stickNavHandler,
    primaryNavSubItemsHandler,
    hidePrimaryMenuBottomHandler,
} from './furniture/_menu'
import { toggleEditionClass } from './furniture/_edition'
import { authorsImageAndTextHandler } from './furniture/_author'
import { previousYearHandler } from './components/draft_pages/_previous-draft-picks'
import { accordionTeamDetailsHandler } from './components/draft_pages/_mock-draft'
import { accordionFaqsHandler } from './components/draft_pages/_accordion-faqs'
import { navigateToPage } from './components/helpers/_navigate-handler'
import { addTextStyle, setScrollBehaviour, initialCheckedHandler, refreshDraftPage } from './components/draft_pages/_tracker'
import { seasonsFilterHandler, teamsFilterHandler } from './components/helpers/_filters-handlers'
import { roundNavigationHandler, overflowFilterHandler } from './components/draft_pages/_filter-dropdown'
import { isMobile, isDesktop, newsCount } from './common/_constants'
import { mobileTopMPU1, removeSidebarAdvert, revcontentAttrHandler } from './components/article/_advertising-containers'
import { relatedArticlesHandler } from './components/article/_related-news'
import { descendingOrderHandler } from './components/slidelist/_slides-numbering'
import { rebuildTables } from './components/article/_tables'
import { lazyLoadHandler, loadMoreItemsHandler, removeServiceWorker } from './components/helpers/_observer-handler'
import { countElements } from './components/helpers/_element-handlers'
import { glideConfig, glideSliderHandler } from './components/gallery/_glide-slider'
import { fetchMoreNews } from './components/article/_more-news'
import { leagueDropdownToggleHandler, leagueNewSelectedHandler } from './components/metabet/_league'
import { hideDropdownListHandle, scorecardCricketSelectClickHandle, standingCricketSelectClickHandle, fixtureCricketSelectClickHandle, leaderboardGolfSelectClickHandle, scheduleGolfSelectClickHandle, scoreboardTennisSelectClickHandle, scheduleTennisSelectClickHandle } from './components/opta/_dropdowns'
import { nbaLogoHandler, nbaSubMenuHandler } from './components/sib/_sub_menu'
import { nbaRedirection, nbaSetDefaultEdition } from './components/sib/_global_menu'
import { metabetRedirectionHandler } from './components/metabet/_redirection'

// Structure from previous js

removeServiceWorker()

document.addEventListener('DOMContentLoaded', () => {
    lazyLoadTweetsHandler()

    sibPageHandlers()

    mobileAndDesktopHandlers()

    navigationsHandlers()

    draftPageHandlers()

    articlePageHandlers()

    slidelistPageHandlers()

    galleryPageHandlers()

    commercialPageHandlers()

    metabetPageHandlers()

    optaPageHandlers()

    pagesHandlers()

})

const navigationsHandlers = () => {
    stickNavHandler()
    primaryNavSubItemsHandler()
    // hidePrimaryMenuBottomHandler()
    highlightSubNavHandler()
}

const mobileAndDesktopHandlers = () => {
    if (isMobile()) {
        getHeightSideNav()
        toggleEditionClass()
        mobileMenuButtonHandler()
        mobileMenuArrowHAndler()
        thirdLevelMenuHandler()
    } else {
        primaryNavHandler()
    }
    moreItemsToggleHandler()
}

const draftPageHandlers = () => {
    const landingDraftPage = document.querySelector('.drafts-landing-page')
    const teamByTeamPage = document.querySelector('.drafts-team-by-team-page')
    const mockDraftPage = document.querySelector('.mock-draft-page')
    const roundByRoundPage = document.querySelector('.drafts-round-by-round-page')

    if (landingDraftPage) {
        previousYearHandler()
        navigateToPage()
        addTextStyle()
        initialCheckedHandler()
        setScrollBehaviour()
        accordionFaqsHandler()
        refreshDraftPage()
    }

    if (teamByTeamPage || roundByRoundPage) {
        seasonsFilterHandler()
        teamsFilterHandler()
        accordionTeamDetailsHandler()
        roundNavigationHandler()
        overflowFilterHandler()
    }

    if (mockDraftPage) {
        seasonsFilterHandler()
        teamsFilterHandler()
        accordionTeamDetailsHandler()
    }
}

const articlePageHandlers = () => {
    const articlePage = document.querySelector('.article-page')
    if (articlePage) {
        // Place videoPlayerHandler after second paragraph of article
        const articlePragraphs = articlePage.querySelectorAll('#article-body > div > p')
        const articlePragraphCount = articlePragraphs.length
        const videoContainer = document.querySelector('.zephr-feature_video-player')

        if (articlePragraphCount >= 2) {
            articlePragraphs[1].after(videoContainer)
        }

        if (isMobile()) {
            removeSidebarAdvert()
            mobileTopMPU1()
        }

        relatedArticlesHandler('#article-body > div > p')
        revcontentAttrHandler()
        authorsImageAndTextHandler()
        fetchMoreNews()
        rebuildTables()
    }
}

const slidelistPageHandlers = () => {
    const slidelistPage = document.querySelector('.slidelist-page')
    if (slidelistPage) {
        countElements('.slide-container', '.total-slides .count')
        authorsImageAndTextHandler()
        descendingOrderHandler()
        relatedArticlesHandler('.slide-container')
        fetchMoreNews()
    }
}

const galleryPageHandlers = () => {
    const galleryPage = document.querySelector('.gallery-page')
    if (galleryPage) {
        glideConfig()
        glideSliderHandler()
        countElements('.glide__slide', '.total-photos .count')
        authorsImageAndTextHandler()
        relatedArticlesHandler('#gallery-body > p')
        fetchMoreNews()
    }
}

const commercialPageHandlers = () => {
    const commercialPage = document.querySelector('.commercial-page')
    if (commercialPage) {
        relatedArticlesHandler('#commercial-body > p')
    }
}

const metabetPageHandlers = () => {
    const metabetPage = document.querySelector('.metabet-page')
    if (metabetPage) {
        leagueDropdownToggleHandler()
        leagueNewSelectedHandler()
        metabetRedirectionHandler()
    }
}

const optaPageHandlers = () => {
    const optaPage = document.querySelector('.opta-page')
    if (optaPage) {
        hideDropdownListHandle()
        scorecardCricketSelectClickHandle()
        standingCricketSelectClickHandle()
        fixtureCricketSelectClickHandle()
        leaderboardGolfSelectClickHandle()
        scheduleGolfSelectClickHandle()
        scoreboardTennisSelectClickHandle()
        scheduleTennisSelectClickHandle()
        fetchMoreNews()
    }
}

const sibPageHandlers = () => {
    const sibPage = document.querySelector('.widget-global-navigation')
    if (sibPage) {
        nbaLogoHandler()
        nbaSubMenuHandler()
        nbaSetDefaultEdition()
        nbaRedirection()
        highlightSubNavHandler()
    }
}

const pagesHandlers = () => {
    const articlePage = document.querySelector('.article-page')
    const slidelistPage = document.querySelector('.slidelist-page')
    const galleryPage = document.querySelector('.gallery-page')
    const commercialPage = document.querySelector('.commercial-page')
    const newsPage = document.querySelector('.news-page')
    const taxonomyPage = document.querySelector('.taxonomy-page')
    const authorPage = document.querySelector('.author-page')

    if (slidelistPage || articlePage || galleryPage || commercialPage) {
        const loadInitialResource = '.skeleton-container'
        const moreNewsImgs = '.more-from-tsn-section__body .list-item a .list-item__img'
        const listItem = '.list-item'
        const unsetlistItem = 'hide'

        // Lazy load articles image
        lazyLoadHandler(loadInitialResource, moreNewsImgs, listItem, unsetlistItem)
    }

    if (newsPage || authorPage || taxonomyPage) {
        const { initialItemsCount, addItemsCount } = newsCount
        const loadInitialResource = '.skeleton-container'
        const loadArticle = '.news-section__list .list-item a .list-item__img'
        const listItem = '.list-item'
        const unsetlistItem = 'hide'
        const loadMoreButton = document.querySelector('.pager__item button')
        const itemsContainer = [...document.querySelectorAll('.news-section__container')]

        // Handles load more articles and lazy load articles image
        loadMoreItemsHandler(itemsContainer, initialItemsCount, addItemsCount, loadMoreButton)
        lazyLoadHandler(loadInitialResource, loadArticle, listItem, unsetlistItem)
    }
}

window.addEventListener('resize', () => {
    removeSidebarAdvert()
    checkScreenWidth()
    stickNavHandler()
    getHeightSideNav()
    primaryNavSubItemsHandler()
    primaryNavHandler()
    mobileMenuArrowHAndler()
    nbaLogoHandler()
    nbaSubMenuHandler()
    highlightSubNavHandler()
    toggleEditionClass()
    mobileMenuButtonHandler()
    moreItemsToggleHandler()
})

let dateDiffInit

jQuery.date = function (dateObject, edition) {
    const d = new Date(dateObject)
    let day = d.getDate()
    let month = d.getMonth() + 1
    const year = d.getFullYear()
    if (day < 10) {
        day = '0' + day
    }

    if (month < 10) {
        month = '0' + month
    }

    let date = ''

    switch (edition) {
        case "india":
        case "argentina":
        case "spain":
        case "mexico":
        case "united_kingdom":
        case "new_zealand":
        case "singapore":
        case "malaysia":
        case "thailand":
        case "vietnam":
            date = day + "-" + month + "-" + year
            break
        case "south_korea":
        case "hong_kong":
            date = year + "-" + month + "-" + day
            break

        default:
            date = month + "-" + day + "-" + year
    }

    return date
}

function tsnDateDiff() {
    const published = jQuery('.author-top-section .published-datetime')
    if (published.length > 0 && !dateDiffInit) {
        dateDiffInit = true
        const tsnEdition = published.attr('data-tsnedition')
        const presentDate = Date.now()
        const publishDate = published.data('timestamp-ms') * 1000
        const tsnDateDiffValue = presentDate - publishDate
        if (tsnDateDiffValue < 0) {
            return -1
        }

        const interval = {
            second: 1000,
            minute: 60_000,
            hour: 3_600_000,
            day: 86_400_000,
        }

        const result = {
            measure: false,
            value: false,
        }

        if (tsnDateDiffValue < interval.second) {
            published.html('less than a second ago')
            return 1
        }

        if (tsnDateDiffValue >= interval.day) {
            published.html(jQuery.date(publishDate, tsnEdition))
            return 2
        }

        if (tsnDateDiffValue >= interval.second && tsnDateDiffValue < interval.minute) {
            result.measure = 'second'
            result.value = Math.round(tsnDateDiffValue / interval.second)
            result.text = result.value > 1 ? `${result.value} seconds ago` : '1 second ago'
        }

        if (tsnDateDiffValue >= interval.minute && tsnDateDiffValue < interval.hour) {
            result.measure = 'minute'
            result.value = Math.round(tsnDateDiffValue / interval.minute)
            result.text = result.value > 1 ? `${result.value} minutes ago` : '1 minute ago'
        }

        if (tsnDateDiffValue >= interval.hour && tsnDateDiffValue < interval.day) {
            result.measure = 'hour'
            result.value = Math.round(tsnDateDiffValue / interval.hour)
            result.text = result.value > 1 ? `${result.value} hours ago` : '1 hour ago'
        }

        if (result.measure && result.value) {
            published.html(result.text)
            return 3
        }

        return -1
    }
}

const backToTop = jQuery('.back-to-top')
const hamburger = jQuery('.hamburger-icon')
const menuMobile = jQuery('.menus-mobile')
const footerLinks = jQuery('.region-footer #block-footer .menu .menu-item a')
const optaWidgetDropdownBtn = jQuery('.opta-section-dropdown__header')
const optaWidgetDropdownList = jQuery('.opta-section-dropdown__list')
const footerMenu = jQuery('.footer-menu')
const secondaryLinks = jQuery('.tsn-primary-menu .tsn-primary-menu__top .menu .menu-item .menu .menu-item')

const adSticky = jQuery('.topBanner-sticky')
const regionHeader = jQuery('.region-header')
const primaryMenuTop = jQuery('.tsn-primary-menu__top')[0].clientHeight
function checkScreenWidth() {
    if (isDesktop()) {
        const auNBAEdition = window.location.href.includes('au/nba')
        const jpNBAEdition = window.location.href.includes('jp/nba')
        jQuery(window).scroll(() => {
            if (auNBAEdition || jpNBAEdition) {
                const widgetGlobalTop = jQuery('.widget-global-navigation')[0].clientHeight
                if (
                    document.documentElement.scrollTop >=
                    regionHeader[0].clientHeight + primaryMenuTop + widgetGlobalTop
                ) {
                    adSticky.addClass('desktop-remove__sticky')
                    adSticky.removeClass('desktop-active__sticky')
                    adSticky.css('top', `jQuery{regionHeader[0].clientHeight+primaryMenuTop+ widgetGlobalTop}px`)
                    regionHeader.css('margin-top', `${adSticky[0].clientHeight}px`)
                } else {
                    adSticky.addClass('desktop-active__sticky')
                    adSticky.removeClass('desktop-remove__sticky')
                    adSticky.css('top', '0')
                    regionHeader.css('margin-top', `${adSticky[0].clientHeight}px`)
                }
            } else if (document.documentElement.scrollTop >= regionHeader[0].clientHeight + primaryMenuTop) {
                adSticky.addClass('desktop-remove__sticky')
                adSticky.removeClass('desktop-active__sticky')
                adSticky.css('top', `${regionHeader[0].clientHeight + primaryMenuTop}px`)
                regionHeader.css('margin-top', `${adSticky[0].clientHeight}px`)
            } else {
                adSticky.addClass('desktop-active__sticky')
                adSticky.removeClass('desktop-remove__sticky')
                adSticky.css('top', '0')
                regionHeader.css('margin-top', `${adSticky[0].clientHeight}px`)
            }
        })
    }
}

checkScreenWidth()

function jumpToLatestNews() {
    jQuery('.scroll-to').on('click', () => {
        const target = jQuery('#lastestNewsSection').offset().top - jQuery('.topBanner-sticky')[0].clientHeight
        if (isMobile()) {
            jQuery('html, body').animate({ scrollTop: target }, 1500)
        } else {
            window.scrollTo({
                top: target,
                behavior: 'smooth',
            })
        }
    })
}

// Function for TSN-1804
function navigate() {
    if (jQuery('.march-madness-page').length > 0) {
        const slideContent = document.querySelectorAll('.slide')
        let i = 0
        const prYr = document.querySelectorAll('.yr')
        const btnPrevious = document.querySelector('.btn_prev')
        const btnNext = document.querySelector('.btn_next')

        jQuery(slideContent[i]).css('display', 'flex')
        jQuery(slideContent[i]).siblings().css('display', 'none')

        jQuery(prYr[i]).css('display', 'flex')
        jQuery(prYr[i]).siblings().css('display', 'none')

        btnPrevious.addEventListener('click', () => {
            if (i !== 0) {
                --i
                jQuery(slideContent[i]).css('display', 'flex')
                jQuery(slideContent[i]).siblings().css('display', 'none')

                jQuery(prYr[i]).css('display', 'flex')
                jQuery(prYr[i]).siblings().css('display', 'none')
            }
        })

        btnNext.addEventListener('click', () => {
            if (i < 3) {
                ++i
                jQuery(slideContent[i]).css('display', 'flex')
                jQuery(slideContent[i]).siblings().css('display', 'none')

                jQuery(prYr[i]).css('display', 'flex')
                jQuery(prYr[i]).siblings().css('display', 'none')
                // Document.querySelector('.btn_next').disabled = false;
                // if (i==3) {
                //   document.querySelector('.btn_prev').disabled = true;
                //   document.querySelector('.btn_next').disabled = false;
                // }
            }
        })
    }
}

function lazyLoadTweetsHandler() {
    const twitterTweets = document.querySelectorAll('.twitter-tweet')
    const txtArray = []

    if (twitterTweets.length > 0) {
        twitterTweets.forEach((tweet, index) => {
            const twitterLink = tweet.querySelector('a').getAttribute('href')
            const div = document.createElement('div')
            div.className = 'lozad'
            div.setAttribute('data-twitter-src', twitterLink)
            div.setAttribute('data-order', index)
            tweet.parentNode.replaceChild(div, tweet)
            txtArray.push(tweet.innerHTML)
        })


        const observer = lozad('.lozad', {
            load(element) {
                const bq = document.createElement('blockquote')
                bq.className = 'twitter-tweet'

                const div = document.createElement('div')
                div.innerHTML = txtArray[element.dataset.order]
                bq.append(div)

                const script = document.createElement('script')
                script.src = 'https://platform.twitter.com/widgets.js'
                script.charset = 'utf8'
                script.async = true

                element.insertAdjacentElement('beforeEnd', bq)
                element.insertAdjacentElement('beforeEnd', script)
            },
        })
        observer.observe()
    }
}

function highlightOptaDate() {
    // Focus on highlighted date
    const dateWidthArray = []
    jQuery('.Opta-On')
        .prevAll()
        .each(function () {
            const dateContainerWidth = jQuery(this).innerWidth()
            dateWidthArray.push(dateContainerWidth)
        })
    let summationOfWidth = 0
    for (const element of dateWidthArray) {
        summationOfWidth += element
    }

    const dateNavigation = jQuery('ul.Opta-Cf')
    dateNavigation.css({ left: -summationOfWidth })

    // Add arrows element and functionalities
    if (isMobile()) {
        jQuery('.Opta-Nav').append(
            "<span class='Opta-Scroller Opta-Previous prev Opta-Active'></span>",
            "<span class='Opta-Scroller Opta-Next Opta-Active'></span>"
        )
        jQuery('.Opta-Previous').click(() => {
            dateNavigation.animate({ left: -(summationOfWidth -= 240) })
        })
        jQuery('.Opta-Next').click(() => {
            dateNavigation.animate({ left: -(summationOfWidth += 240) })
        })
    }

    // Picking date
    const datePicker = jQuery('.Opta-DatePicker-Body')
    jQuery(datePicker).click(() => {
        highlightOptaDate()
    })
}

function selectCurretOptaData() {
    if (jQuery('body').hasClass('path-nba')) {
        // Remove class that selected by opta
        jQuery('.Opta-On').removeClass('Opta-On')
        const date = new Date()
        const currentDate = `${date.toLocaleString('default', { month: 'short' })} ${date.getUTCDate().toString()}`
        // Add class to current date
        jQuery(`a:contains(${currentDate})`).parent().addClass('Opta-On')
    }
}

// Checking if opta widget class is already loaded
function waitForOptaWidget(selector, callback) {
    if (jQuery('#opta-widget').length > 0) {
        if (jQuery(selector).length > 0) {
            callback()
        } else {
            setTimeout(() => {
                waitForOptaWidget(selector, callback)
            }, 100)
        }
    }
}

// Execute functions after opta widget is rendered
waitForOptaWidget('.Opta-Cf', () => {
    selectCurretOptaData()
    highlightOptaDate()
})

jQuery(document).ready(() => {
    tsnDateDiff()
    jumpToLatestNews()
    navigate()

    jQuery('.primary-menu-wrapper > .menu > .more > .more-submenu').click((event) => {
        event.stopPropagation()
    })

    jQuery(document).on('click', (event) => {
        if (jQuery(event.target).closest('.primary-menu-wrapper > .menu > .more').length === 0) {
            jQuery('.primary-menu-wrapper > .menu > .more').removeClass('is-active')
        }
    })

    jQuery(document).on('click', (event) => {
        if (jQuery(event.target).closest('.nba-menu-wrapper > .nba-menu-inner > .menu > .more-second').length === 0) {
            jQuery('.nba-menu-wrapper > .nba-menu-inner > .menu > .more-second').removeClass('is-active')
        }
    })

    jQuery('.primary-menu-wrapper > .menu > .more > .more-submenu > .menu-item > .has-children__arrow')
        .one()
        .click(function (event) {
            event.stopPropagation()
            jQuery(this).closest('.menu-item').toggleClass('is-open')
        })

    // Toggle domain navigation menu
    jQuery('#block-tsndomainnavigation .menu')
        .one()
        .click(function () {
            jQuery(this).toggleClass('open')
        })

    jQuery('.editions-mobile #block-tsndomainnavigation .menu')
        .one()
        .click(function () {
            jQuery(this).toggleClass('has-children__arrow')
        })

    jQuery('#block-tsndomainnavigation .menu a.link')
        .one()
        .click((event) => {
            const cookieName = 'sn-edition'
            const cookieTtl = 30
            const target = event.currentTarget
            const edition = target.dataset.edition || ''

            // Check for valid edition
            if (
                edition.length === 0 ||
                jQuery(`#block-tsndomainnavigation .menu .link[data-edition='jQuery{edition}']`).length === 0
            ) {
                return true
            }

            Cookies.set(cookieName, edition, { expires: cookieTtl })

            return true
        })

    jQuery(document)
        .one()
        .click((event) => {
            const jQuerytarget = jQuery(event.target)
            if (
                jQuerytarget.closest('#block-tsndomainnavigation').length === 0 &&
                jQuery('#block-tsndomainnavigation').is(':visible')
            ) {
                jQuery('#block-tsndomainnavigation .menu').removeClass('open')
            }
        })

    // Toggle opta-widgets list
    optaWidgetDropdownBtn.on('click', (event) => {
        const dropArrow = event.currentTarget
        const list = event.currentTarget.parentNode.lastElementChild
        if (!jQuery(dropArrow).attr('class').match('is-active')) {
            jQuery(optaWidgetDropdownBtn).removeClass('is-active')
            jQuery(optaWidgetDropdownList).removeClass('is-active')
            jQuery(dropArrow).toggleClass('is-active')
            jQuery(list).toggleClass('is-active')
        } else {
            jQuery(optaWidgetDropdownBtn).removeClass('is-active')
            jQuery(optaWidgetDropdownList).removeClass('is-active')
        }
    })

    // @todo: add the ability to open footer menu links in new window
    footerMenu.children('.menu-item').each(function () {
        const link = jQuery(this).children('a').first()

        if (link) {
            const href = link.attr('href')

            if (href.includes('sportingnewsholdings.com')) {
                link.attr('target', '_blank')
            }
        }

        // Check if Footer Menu is Privacy Settings, then add 'ot-sdk-show-settings' class for the modal to show
        const content = jQuery(this).text().trim()
        if (content === 'Privacy Settings') {
            jQuery(this)
                .children('a')
                .addClass('ot-sdk-show-settings')
                .css('cursor', 'pointer')
                .on('click', () => false)
        }
    })
})

jQuery(window).scroll(() => {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20 || window.pageYOffset > 20) {
        backToTop.css('display', 'block')
    } else {
        jQuery('html, body').stop()
        backToTop.css('display', 'none')
    }
})

// Open footer links in new tabs
footerLinks.off()
footerLinks.on('click', function () {
    jQuery(this).attr('target', '_blank')
})

backToTop.off('click')
backToTop.on('click', () => {
    jQuery('html, body').animate({ scrollTop: 0 }, 700)
    return false
})

hamburger.off('click')
hamburger.on('click', () => {
    if (menuMobile.css('display') === 'none') {
        menuMobile.css('display', 'block')
    } else {
        menuMobile.css('display', 'none')
    }
})

secondaryLinks.hover(function () {
    if (jQuery(this).children('.menu').length > 0 && isDesktop()) {
        jQuery(this).children('.menu').css('visibility', 'visible')
    }
})
